import { api } from './api';

export type ReferralRewardMode = 'incpt' | 'liquid';
export type ReferralVaultKind = 'liquid' | 'monthly' | 'maximum';

export interface ReferralRewardRow {
  paidAs: ReferralRewardMode;
  rewardUsd: string;
  paidAmount: string;
  vaultKind: string;
  createdAt: string;
}

export interface ReferralOverview {
  code: string;
  /** Mini App deep link carrying this user's code. */
  link: string;
  invitedCount: number;
  invited: { name: string; joinedAt: string }[];
  rewardMode: ReferralRewardMode;
  enabled: boolean;
  rewardPct: number;
  vaults: ReferralVaultKind[];
  earnedUsd: string;
  earnedIncpt: string;
  earnedLiquidUsd: string;
  recentRewards: ReferralRewardRow[];
}

export const fetchReferral = (initData: string) =>
  api<ReferralOverview>(initData, '/v1/me/referral');

export const patchReferralMode = (initData: string, rewardMode: ReferralRewardMode) =>
  api<{ rewardMode: ReferralRewardMode }>(initData, '/v1/me/referral', {
    method: 'PATCH',
    body: JSON.stringify({ rewardMode }),
  });
